import { useTeamPresence } from "../../../contexts/TeamPresenceContext";

const useTeamSocket = () => {
  const presence = useTeamPresence();
  return presence;
};

export default useTeamSocket;
